import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';

const ListCard = ({
	followList,
	setCurrentId,
	setModalState,
	setShowList,
	formDispatch,
}) => {
	const [popUpState, setPopUpState] = useState(false);

	const deleteButton = () => {
		setCurrentId(followList.id);
		setModalState('delete');
		setPopUpState(false);
	};

	const editButton = () => {
		setCurrentId(followList.id);
		setModalState('edit');
		formDispatch({ type: 'FILL', payload: { name: followList.name } });
		setPopUpState(false);
	};

	const ImageSection = () => {
		if (
			followList == null ||
			followList.organizations == null ||
			followList.articles == null
		) {
			return null;
		}
		const orgImgs = followList.organizations
			.slice(0, 3)
			.filter(
				(orgData) =>
					orgData.logo?.url != null &&
					orgData.logo?.url != 'default-organization.png'
			)
			.map((orgData) => orgData.logo?.url);
		const articleImgs = followList.articles
			.slice(0, 3)
			.filter((articleData) => articleData.article.img_url)
			.map((articleData) => articleData.article.img_url);
		const allObjects = articleImgs.concat(orgImgs);

		if (allObjects.length == 0) return null;

		if (allObjects.length == 1) {
			return <img src={allObjects[0]} />;
		}
		if (allObjects.length == 2) {
			return (
				<>
					<div className="half-container">
						<img src={allObjects[0]} />
					</div>
					<div className="half-container">
						<img src={allObjects[1]} />
					</div>
					<br style={{ clear: 'both' }} />
				</>
			);
		}
		if (allObjects.length > 2) {
			return (
				<>
					<div className="half-container">
						<img src={allObjects[0]} />
					</div>
					<div className="half-container">
						<div className="half-container">
							<img src={allObjects[1]} />
						</div>
						<div className="half-container">
							<img src={allObjects[2]} />
						</div>
					</div>
				</>
			);
		}
		return null;
	};

	return (
		<div className="columns small-12 medium-6" style={{ float: 'left' }}>
			<div
				className="list-card card"
				style={{ overflow: 'visible' }}
				onMouseLeave={() => setPopUpState(false)}
			>
				<div
					className="image-section"
					onClick={() => setShowList(followList)}
				>
					<ImageSection />
				</div>
				<div className="bottom-section">
					<div className="list-card-title">{followList.name}</div>
					{followList.organizations &&
					followList.organizations.length ? (
						<strong
							style={{ marginRight: '0.5rem' }}
						>{`Organizations (${followList.organizations.length})`}</strong>
					) : null}
					{followList.articles && followList.articles.length ? (
						<strong>{`Articles (${followList.articles.length})`}</strong>
					) : null}
					<div
						className="gear-icon"
						onClick={() => setPopUpState(!popUpState)}
					>
						<div style={{ position: 'relative' }}>
							<FontAwesomeIcon icon={faCog} size="2x" />
							<div
								className={
									'pop-up' + (popUpState ? ' active' : '')
								}
							>
								<div
									className="pop-up-section bottom-border"
									onClick={editButton}
								>
									Edit list
								</div>
								<div
									className="pop-up-section"
									onClick={deleteButton}
								>
									Delete list
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ListCard;
